<div
  class="sb-container"
  kendoDialogContainer
  *ngIf="{ templates: templates$ | async } as data"
>
  <div #spacer></div>
  <header class="sb-header" stickyThing [spacer]="spacer">
    <div class="grid-x">
      <div class="small-7 cell">
        <ul class="sb-tab-menu">
          <li>
            <a class="is-active">Templates</a>
          </li>
        </ul>
      </div>

      <div class="small-5 cell align-self-middle"></div>
    </div>
  </header>
  <main class="sb-content">
    <!-- Page Header Section-->
    <header class="sb-content-header">
      <div class="grid-x align-middle">
        <div class="small-8 cell">
          <ul class="sb-breadcrumbs">
            <li class="is-parent"><span>Solution Builder</span></li>
            <li class="is-divider"><span>/</span></li>
            <li class="is-parent"><a [routerLink]="'/admin'">Settings</a></li>
            <li class="is-divider"><span>/</span></li>
            <li class="is-active"><span class="">Templates</span></li>
          </ul>
          <h1 class="sb-content-heading">Templates</h1>
        </div>
        <div class="small-4 cell text-right">
          <div class="sb-flow-list-actions">
            <button kendoButton primary="true" [routerLink]="['./', -1]">
              New Template
            </button>
          </div>
        </div>
      </div>
    </header>
    <!-- Filter Section-->
    <section class="sb-filter-section">
      <div class="grid-x grid-padding-x" [formGroup]="fgTemplateFilter">
        <div
          class="cell"
          [class.small-3]="fcAvailability.value == 'Branch'"
          [class.small-6]="fcAvailability.value != 'Branch'"
        >
          <sb-text-field
            placeholder="Filter Templates"
            iconClass="fal fa-search"
            [control]="fcFilter"
          ></sb-text-field>
        </div>
        <div class="small-3 cell hide">
          <sb-dropdown-field
            [options]="vendors$ | async"
            [control]="fcVendor"
            [filled]="fcVendor.value"
          ></sb-dropdown-field>
        </div>
        <div class="small-3 cell hide">
          <sb-dropdown-field
            [options]="availability$ | async"
            [filled]="fcAvailability.value"
            [control]="fcAvailability"
          ></sb-dropdown-field>
        </div>
        <div
          class="small-3 cell"
          [class.hide]="fcAvailability.value != 'Branch'"
        >
          <sb-dropdown-field
            [options]="branches$ | async"
            [filled]="fcBranch.value"
            [control]="fcBranch"
          ></sb-dropdown-field>
        </div>
      </div>
    </section>
    <!-- Template List Section-->
    <section class="sb-flow-list-section">
      <div class="grid-x grid-padding-x">
        <div class="cell">
          <div class="sb-flow-item-list">
            <sb-callout *ngIf="data.templates.length === 0" warn="true"
              >No Templates found.</sb-callout
            >
            <div class="grid-x grid-padding-x">
              <div
                class="small-12 cell"
                *ngFor="let item of data.templates; index as i"
              >
                <div class="sb-flow-item-wrapper">
                  <div
                    class="sb-flow-item"
                    [class.is-selected]="item.isSelected"
                    kendoTooltip
                  >
                    <div class="sb-flow-item-content">
                      <span
                        class="sb-flow-item-name"
                        [attr.title]="item.name"
                        >{{ item.name }}</span
                      >
                      <div class="sb-flow-actions">
                        <button
                          kendoButton
                          primary="true"
                          [routerLink]="['./', item.id]"
                        >
                          Edit
                        </button>
                        <button
                          kendoButton
                          class="warning"
                          (click)="showConfirmRemoveDialog(item)"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</div>
